module.exports = __webpack_public_path__ + "static/media/flyer.5de95512.png";